/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { IMediaModel, RouteHelper } from "@nf/common";
import { useTranslation } from "next-i18next";

import Button from "components/Button";
import { useSyncCompleted } from "hooks";

import InfoCircleIcon from "resources/icons/info-circle.svg";

export interface MoreInfoButtonProps {
  media?: IMediaModel;
}

export const MoreInfoButton = ({ media }: MoreInfoButtonProps) => {
  const { t } = useTranslation("translations");

  const isAuthProcessCompleted = useSyncCompleted();

  return (
    <Button
      href={RouteHelper.goToDetails(media)}
      size="large"
      variant="secondary"
      icon={<InfoCircleIcon />}
      state={!isAuthProcessCompleted ? "skeleton" : undefined}
    >
      {t("web_highlight_asset_button_more_info")}
    </Button>
  );
};

export default MoreInfoButton;
